// extracted by mini-css-extract-plugin
export var backdropBlur = "_l1-0";
export var contentCard = "_l1-5";
export var frame = "_l1-2";
export var image = "_l1-4";
export var imagePane = "_l1-3";
export var modal = "_l1-1";